import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { Box, Typography } from '@mui/material';
import MensureLoader from '../../atoms/MensureLoader';

const ProtectedRoute = ({ children, requireAdmin = false, requireMensure = false, requireAdminOrMensure = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <MensureLoader fullScreen size="md" message="Verificando autenticacao..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar permissões específicas
  if (requireAdmin && user.role !== 'admin') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
          p: 3
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Você precisa de permissões de administrador para acessar esta página.
        </Typography>
      </Box>
    );
  }

  if (requireMensure && user.role !== 'mensure') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
          p: 3
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Você precisa de permissões do time Mensure para acessar esta página.
        </Typography>
      </Box>
    );
  }

  if (requireAdminOrMensure && !(user.role === 'admin' || user.role === 'mensure')) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
          p: 3
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Você precisa de permissões administrativas para acessar esta página.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
